import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthCheck } from './auth-check';
import { LynxLocalizeRouterService } from './core/services/localize-router.service';
import { LobbyCheck } from './lobby-check';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';

const getQueryString = () => {
  const query = window.location.href.split('?')[1];
  return query ? `?${query}` : '';
};

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
    canActivate: [LobbyCheck]
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomeModule),
    canActivate: [AuthCheck, LobbyCheck]
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
    canActivate: [LobbyCheck]
  },
  {
    path: '404',
    component: PageNotFoundComponent
  },
  {
    path: ':locale',
    children: [
      {
        path: 'home',
        redirectTo: `/home${getQueryString()}`,
        pathMatch: 'full'
      },
      {
        path: 'login',
        redirectTo: `/login${getQueryString()}`,
        pathMatch: 'full'
      },
      {
        path: '404',
        redirectTo: `/404${getQueryString()}`,
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      enableTracing: false,
      onSameUrlNavigation: 'ignore'
    })
  ],
  exports: [RouterModule],
  providers: [AuthCheck, LobbyCheck, LynxLocalizeRouterService]
})
export class AppRoutingModule {}
